import { translate } from 'i18n/i18n'
import { formatDateRange } from './_utils/formatDateRange'
import { formatPercentageChange } from './_utils/formatPercentageChange'
import { NDVIImageColumn } from './NDVIImageColumn'
import type { TNDVIBlockRowProps } from './types'

export const NDVIBlockRow = ({
  block,
  blockName,
  imageDateMoment,
  previousImageDateMoment,
  lastMonthImageDateMoment,
}: TNDVIBlockRowProps) => (
  <div css={{ margin: '20px auto', maxWidth: 800 }}>
    <div>
      <div css={{ fontWeight: 'bold', marginBottom: 10 }}>{blockName}</div>
      <div
        css={{
          margin: '20px auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 20,
          alignItems: 'start',
        }}
      >
        <NDVIImageColumn
          src={block.current_image.src}
          blockId={block.block_id}
          title={`${translate.phrases.banyanApp('Latest Image:')} ${block.current_image.image_date}`}
          metrics={[
            { label: translate.phrases.banyanApp('Avg NDVI:'), value: block.current_image.ndvi_mean },
            { label: translate.phrases.banyanApp('Uniformity:'), value: block.current_image.uniformity },
          ]}
        />

        {block.since_last_image && previousImageDateMoment ? (
          <NDVIImageColumn
            src={block.since_last_image.src}
            blockId={block.block_id}
            title={formatDateRange(previousImageDateMoment, imageDateMoment)}
            metrics={[
              {
                label: translate.phrases.banyanApp('NDVI change:'),
                value: formatPercentageChange(block.since_last_image.ndvi_mean_change, 100),
              },
              {
                label: translate.phrases.banyanApp('Uniformity change:'),
                value: formatPercentageChange(block.since_last_image.uniformity_change),
              },
            ]}
          />
        ) : (
          <div />
        )}

        {block.since_last_month?.src && lastMonthImageDateMoment ? (
          <NDVIImageColumn
            src={block.since_last_month.src}
            blockId={block.block_id}
            title={formatDateRange(lastMonthImageDateMoment, imageDateMoment)}
            metrics={[
              {
                label: translate.phrases.banyanApp('NDVI change:'),
                value: formatPercentageChange(block.since_last_month.ndvi_mean_change, 100),
              },
              {
                label: translate.phrases.banyanApp('Uniformity change:'),
                value: formatPercentageChange(block.since_last_month.uniformity_change),
              },
            ]}
          />
        ) : (
          <div />
        )}
      </div>
    </div>
  </div>
)
